import { __assign, __awaiter, __generator } from "tslib";
import { createHttpClient } from '@wix/http-client';
;
;
export * from './testkit';
export var createWasabiApi = function (http) {
    var httpClient = createHttpClient();
    return {
        createDashboard: function (addDashboardDto) { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = __assign({}, addDashboardDto);
                        return [4 /*yield*/, http.post("/apps/wasabi/dashboards", data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        editDashboard: function (editDashboardDto) { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = __assign({}, editDashboardDto);
                        return [4 /*yield*/, http.put("/apps/wasabi/dashboards/" + editDashboardDto.dashboardId, data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        getAll: function (_, tenantId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http.get("/apps/wasabi/getAll?tenantId=" + tenantId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        delete: function (deleteDashboardDto) { return __awaiter(void 0, void 0, void 0, function () {
            var data, deleteResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            tenantId: deleteDashboardDto.tenantId,
                        };
                        return [4 /*yield*/, httpClient.delete("https://" + deleteDashboardDto.defaultHost + "/apps/wasabi/dashboards/" + deleteDashboardDto.dashboardId, { data: data })];
                    case 1:
                        deleteResponse = _a.sent();
                        return [2 /*return*/, deleteResponse.data];
                }
            });
        }); },
        duplicate: function (duplicateDto) { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            tenantId: duplicateDto.tenantId,
                            title: duplicateDto.title,
                            description: duplicateDto.description,
                            isDefault: duplicateDto.isDefault,
                        };
                        return [4 /*yield*/, http.post("/apps/wasabi/dashboards/" + duplicateDto.dashboardId + "/duplicate", data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        getAllSchedules: function (tenantId, userEmail) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, http.get("/apps/wasabi/schedules?tenantId=" + tenantId + "&userEmail=" + userEmail)];
            });
        }); },
    };
};
//# sourceMappingURL=index.js.map